<template>
  <div class="box">
    <div class="box-title">组件库</div>
    <div class="contain-class">
      <van-cell-group id="box" class="cell-group-class">
        <van-cell
          class="cell-class"
          v-for="item in components"
          :key="item.id"
          :id="item.id"
          :title="item.name"
          :label="item.label"
          @click="goJump(item.name)"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import common from '../common/js/components'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      components: common.components, // 组件信息
      fieldValue: '', // 搜索输入框输入信息
    }
  },
  mounted() {
    // let boxEle = document.getElementById('box').childNodes
    // console.log(boxEle)
  },
  methods: {
    goJump(name) {
      console.log(name)
      let url = '/' + name + 'Demo'
      this.$router.push(url)
    },
    // goScrollTo() {
    //   window.scrollTo(0, 180)
    // },
    // input() {
    //   console.warn(this.fieldValue)
    // },
  },
}
</script>
<style lang="scss" scoped>
.box {
  width: 375px;
  min-height: 100vh;
  background-color: #f7f8fa;
  &-search {
    padding-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &-title {
    padding: 16px 16px 16px;
    color: rgba(69, 90, 100, 0.6);
    font-size: 22px;
    font-weight: 700;
  }
}
.van-cell {
  width: 100%;
  border-radius: 8px;
}
</style>
